import React, { useState, useEffect } from 'react';

const DEFAULT_PF = { dst_port: '', to_address: '', to_port: '', protocol: 'tcp', comment: '', in_interface: '' };

export default function StepPortForward({ data, onChange, onNext, onBack }) {
  const [rules, setRules] = useState(data && data.length > 0 ? data : [{ ...DEFAULT_PF }]);

  useEffect(() => {
    if (data && data.length > 0) setRules(data);
  }, [data]);

  const update = (index, key, value) => {
    const updated = [...rules];
    updated[index] = { ...updated[index], [key]: value };
    setRules(updated);
    onChange(updated);
  };

  const add = () => {
    const updated = [...rules, { ...DEFAULT_PF }];
    setRules(updated);
    onChange(updated);
  };

  const remove = (index) => {
    if (rules.length <= 1) return;
    const updated = rules.filter((_, i) => i !== index);
    setRules(updated);
    onChange(updated);
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">🔌 เปิดพอร์ต (Port Forward)</h2>
        <p className="text-gray-500 dark:text-gray-400">ส่งต่อการเชื่อมต่อจากภายนอก (อินเทอร์เน็ต) เข้าเซิร์ฟเวอร์ภายในเครือข่าย</p>
      </div>

      <div className="space-y-4">
        {rules.map((pf, index) => (
          <div key={index} className="p-5 bg-gradient-to-br from-gray-50 to-white dark:from-gray-700/50 dark:to-gray-800/50 rounded-xl border border-gray-200 dark:border-gray-600 shadow-sm">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-lg flex items-center justify-center text-sm font-bold shadow-md">{index + 1}</span>
                <span className="font-bold text-gray-900 dark:text-white">{pf.comment || 'กฎที่ ' + (index + 1)}</span>
              </div>
              <button onClick={() => remove(index)} className="btn-danger" disabled={rules.length <= 1}>ลบ</button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="label">พอร์ตภายนอก (Destination Port)</label>
                <input type="text" value={pf.dst_port} onChange={e => update(index, 'dst_port', e.target.value)} className="input-field" placeholder="8080" />
                <p className="text-[10px] text-gray-400 mt-1">พอร์ตที่เปิดจากภายนอก</p>
              </div>
              <div>
                <label className="label">IP เครื่องภายใน</label>
                <input type="text" value={pf.to_address} onChange={e => update(index, 'to_address', e.target.value)} className="input-field" placeholder="192.168.88.100" />
              </div>
              <div>
                <label className="label">พอร์ตภายใน (เว้นว่าง = เหมือนภายนอก)</label>
                <input type="text" value={pf.to_port} onChange={e => update(index, 'to_port', e.target.value)} className="input-field" placeholder="80" />
              </div>
              <div>
                <label className="label">โปรโตคอล</label>
                <select value={pf.protocol} onChange={e => update(index, 'protocol', e.target.value)} className="input-field">
                  <option value="tcp">TCP</option>
                  <option value="udp">UDP</option>
                  <option value="tcp,udp">TCP + UDP</option>
                </select>
              </div>
              <div className="sm:col-span-2">
                <label className="label">💬 หมายเหตุ</label>
                <input type="text" value={pf.comment} onChange={e => update(index, 'comment', e.target.value)} className="input-field" placeholder="เช่น Web Server, Camera, Game Server" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <button onClick={add} className="mt-4 px-4 py-3 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl text-gray-500 dark:text-gray-400 hover:border-orange-500 hover:text-orange-500 transition-colors w-full font-medium text-sm">
        + เพิ่มกฎเปิดพอร์ต
      </button>

      <div className="mt-4 p-3 bg-orange-50 dark:bg-orange-900/10 border border-orange-100 dark:border-orange-800/50 rounded-lg">
        <p className="text-xs text-orange-700 dark:text-orange-300">
          <strong>⚠️ คำเตือน:</strong> การเปิดพอร์ตเป็นการอนุญาตการเชื่อมต่อจากอินเทอร์เน็ตเข้ามาในเครือข่าย ควรเปิดเฉพาะพอร์ตที่จำเป็นเท่านั้น
        </p>
      </div>

      <div className="flex justify-between mt-6">
        <button onClick={onBack} className="btn-secondary">← ย้อนกลับ</button>
        <button onClick={onNext} className="btn-primary">ถัดไป ({rules.length} กฎ)</button>
      </div>
    </div>
  );
}
